import { render, staticRenderFns } from "./CarouselSlide.vue?vue&type=template&id=64a5d4d4&scoped=true&"
import script from "./CarouselSlide.vue?vue&type=script&lang=js&"
export * from "./CarouselSlide.vue?vue&type=script&lang=js&"
import style0 from "./CarouselSlide.vue?vue&type=style&index=0&id=64a5d4d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a5d4d4",
  null
  
)

export default component.exports